/* Animation JS */
jQuery(document).ready(function($) {

  var opacity = 0.0,
      distance = '100%',
      delay = 500,
      reset = true,
      mobile = false,
      origin;


  if( $('body.home').length ) { origin = 'bottom'; } else { origin = 'left'; }

  var slideAnimation = {
      distance: distance,
      origin: origin,
      opacity: opacity,
      delay: delay,
      reset: reset,
      mobile: mobile
  };

  if( $('body.home').length ) {
    ScrollReveal().reveal('.wex-icon', slideAnimation);
  } else {
    // Get all of the icons on the page and apply the animation unless they're nested in an accordion
    $('.wex-icon').each(function() {
      if (!$(this).parent().hasClass("wex-link--icon"))
      {
        ScrollReveal().reveal($(this), slideAnimation);
      }
    });
  }
     
});